import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "children", "title", "isMultiline", "isBroadcast", "isToast", "status", "action", "onDismiss"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Alert.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Alert = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      children = _ref.children,
      title = _ref.title,
      _ref$isMultiline = _ref.isMultiline,
      isMultiline = _ref$isMultiline === void 0 ? false : _ref$isMultiline,
      _ref$isBroadcast = _ref.isBroadcast,
      isBroadcast = _ref$isBroadcast === void 0 ? false : _ref$isBroadcast,
      _ref$isToast = _ref.isToast,
      isToast = _ref$isToast === void 0 ? false : _ref$isToast,
      status = _ref.status,
      action = _ref.action,
      onDismiss = _ref.onDismiss,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-alert"), true), _defineProperty(_cx, "".concat(prefix, "-alert--error"), status === 'error'), _defineProperty(_cx, "".concat(prefix, "-alert--success"), status === 'success'), _defineProperty(_cx, "".concat(prefix, "-alert--warning"), status === 'warning'), _defineProperty(_cx, "".concat(prefix, "-alert--notification"), status === 'notification'), _defineProperty(_cx, "".concat(prefix, "-alert--task"), status === 'task'), _defineProperty(_cx, "".concat(prefix, "-alert--isToast"), isToast), _defineProperty(_cx, "".concat(prefix, "-alert--isDismissable"), onDismiss), _defineProperty(_cx, "".concat(prefix, "-alert--isMultiline"), isMultiline), _defineProperty(_cx, "".concat(prefix, "-alert--isBroadcast"), isBroadcast), _defineProperty(_cx, "".concat(prefix, "-alert--hasAction"), action), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var getIcon = function getIcon(status) {
    var icons = {
      error: 'error',
      success: 'tick-circle',
      notification: 'notifications',
      task: 'clipboard',
      warning: 'warning-sign',
      info: 'info-sign'
    };
    return icons[status] || icons['info'];
  };

  var getIconColor = function getIconColor(status) {
    var colors = {
      error: isToast ? 'var(--dentsu-color-r600)' : 'var(--dentsu-color-red)',
      success: 'var(--dentsu-color-g600)',
      warning: isToast ? 'var(--dentsu-color-a600)' : 'var(--dentsu-color-amber)',
      notification: 'var(--dentsu-color-b600)',
      task: 'var(--dentsu-color-b600)',
      info: 'var(--dentsu-color-b600)'
    };
    return colors[status] || colors['info'];
  };

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(Styled.Alert, _objectSpread(_objectSpread({
      ref: ref,
      className: className,
      role: "alert"
    }, rest), {}, {
      children: [_jsxs(Styled.AlertLayout, {
        className: "".concat(prefix, "-alert__layout"),
        children: [_jsx(Styled.AlertLayoutIcon, {
          className: "".concat(prefix, "-alert__icon"),
          children: _jsx(Styled.AlertIcon, {
            "aria-hidden": "true",
            icon: getIcon(status),
            color: getIconColor(status)
          })
        }), _jsxs(Styled.AlertLayoutText, {
          className: "".concat(prefix, "-alert__text"),
          children: [title && _jsx(Styled.AlertTitle, {
            className: "".concat(prefix, "-alert__title"),
            children: title
          }), children && _jsx(Styled.AlertSubtitle, {
            className: "".concat(prefix, "-alert__subtitle"),
            children: children
          }), action && (isBroadcast || isToast ? _jsx(Styled.AlertLink, {
            className: "".concat(prefix, "-alert__broadcast-link__narrow"),
            onClick: action.onClick,
            isDisabled: action.isDisabled,
            as: action.as,
            url: action.url,
            isExternal: action.isExternal,
            children: action.content
          }) : _jsx(Styled.AlertButtonSmall, {
            className: "".concat(prefix, "-alert__action-button__inline"),
            isLoading: action.isLoading,
            isDisabled: action.isDisabled,
            onClick: action.onClick,
            variant: "secondary",
            size: "small",
            children: action.content
          }))]
        }), action && _jsx(Styled.AlertLayoutAction, {
          className: "".concat(prefix, "-alert__action"),
          children: isBroadcast ? _jsx(Styled.AlertLink, {
            className: "".concat(prefix, "-alert__broadcast-link__wide"),
            onClick: action.onClick,
            as: action.as,
            url: action.url,
            isExternal: action.isExternal,
            isDisabled: action.isDisabled,
            children: action.content
          }) : _jsx(Styled.AlertButtonContainer, {
            className: "".concat(prefix, "-alert__action-button"),
            children: action.isLink ? _jsx(Styled.AlertLink, {
              className: "".concat(prefix, "-alert__broadcast-link__narrow"),
              onClick: action.onClick,
              isDisabled: action.isDisabled,
              as: action.as,
              url: action.url,
              isExternal: action.isExternal,
              children: action.content
            }) : _jsxs(_Fragment, {
              children: [_jsx(Styled.AlertButtonSmall, {
                className: "".concat(prefix, "-alert__action--small"),
                isLoading: action.isLoading,
                isDisabled: action.isDisabled,
                onClick: action.onClick,
                variant: "secondary",
                size: "small",
                children: action.content
              }), _jsx(Styled.AlertButtonLarge, {
                className: "".concat(prefix, "-alert__action--large"),
                isLoading: action.isLoading,
                isDisabled: action.isDisabled,
                onClick: action.onClick,
                variant: "secondary",
                children: action.content
              })]
            })
          })
        })]
      }), onDismiss && _jsx(Styled.AlertCloseButton, {
        onClick: onDismiss,
        className: "".concat(prefix, "-alert__dismiss")
      })]
    }))
  });
});
Alert.displayName = 'Alert';
export default Alert;